import { chatbotFeedbackPostFeedbackAction } from "./action";

import { combineReducers } from "redux";
import { createReducer } from "typesafe-actions";
import createLoadingReducer from "../../../../../libraries/packages/redux-utils/src/request/create-loading-reducer";
import createOperationReducer from "../../../../../libraries/packages/redux-utils/src/request/create-operation-reducer";
import createErrorReducer from "../../../../../libraries/packages/redux-utils/src/request/create-error-reducer";
import api from "../storeApi";

export const chatbotFeedbackReducer = combineReducers<{
  data: typeof api.chatbotFeedback.type;
  lastOpId: string | null;
  isLoading: Set<string>;
  error: Error;
}>({
  data: createReducer(null).handleAction(
    [chatbotFeedbackPostFeedbackAction.success],
    (state, action) => action.payload
  ),
  isLoading: createLoadingReducer(chatbotFeedbackPostFeedbackAction),
  lastOpId: createOperationReducer(chatbotFeedbackPostFeedbackAction),
  error: createErrorReducer(chatbotFeedbackPostFeedbackAction),
});
